/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { initialAutoReportState } from './constants';
import { IAutoReportIdReducer } from './reducer';
import { EPageAutoReportIdType, IAutoReportIdFormatMeta, IAutoReportIdScheduleMeta } from './types';

export const makeSelectorAutoReportIdState = (state: IRootReducer): IAutoReportIdReducer =>
    state.autoReportId || initialAutoReportState;

export const makeSelectorAutoReportCurrentId = ()
    : OutputSelector<IRootReducer, string, (state: IAutoReportIdReducer) => string> =>
    createSelector(
        makeSelectorAutoReportIdState,
        state => state.id,
    );

export const makeSelectorAutoReportIdName = ()
    : OutputSelector<IRootReducer, string, (state: IAutoReportIdReducer) => string> =>
    createSelector(
        makeSelectorAutoReportIdState,
        state => state.name,
    );

export const makeSelectorAutoReportIdType = ()
    : OutputSelector<IRootReducer, EPageAutoReportIdType, (state: IAutoReportIdReducer) => EPageAutoReportIdType> =>
    createSelector(
        makeSelectorAutoReportIdState,
        state => state.type,
    );

export const makeSelectorAutoReportIdIsLoading = ()
    : OutputSelector<IRootReducer, boolean, (state: IAutoReportIdReducer) => boolean> =>
    createSelector(
        makeSelectorAutoReportIdState,
        state => state.isLoading,
    );

export const makeSelectorAutoReportIdIsError = ()
    : OutputSelector<IRootReducer, boolean, (state: IAutoReportIdReducer) => boolean> =>
    createSelector(
        makeSelectorAutoReportIdState,
        state => state.isError,
    );

export const makeSelectorAutoReportIdFormatMeta = (): OutputSelector<IRootReducer, IAutoReportIdFormatMeta,
    (state: IAutoReportIdReducer) => IAutoReportIdFormatMeta> =>
    createSelector(
        makeSelectorAutoReportIdState,
        state => state.formatMeta,
    );

export const makeSelectorAutoReportIdScheduleMeta = (): OutputSelector<IRootReducer, IAutoReportIdScheduleMeta,
    (state: IAutoReportIdReducer) => IAutoReportIdScheduleMeta> =>
    createSelector(
        makeSelectorAutoReportIdState,
        state => state.scheduleMeta,
    );
